var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8FireExtinguisher50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F44336",
    d: "M26,12h-8l-3.1,3.1C13,17,12,19.5,12,22.2V42c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V22.1c0-2.7-1.1-5.2-2.9-7.1L26,12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#607D8B",
    d: "M18 6C11.3 6 6 11.3 6 18h4c0-4.5 3.5-8 8-8h8V6H18zM26 10L34 12 34 4 26 6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M25,36h-6c-0.6,0-1-0.4-1-1V25c0-0.6,0.4-1,1-1h6c0.6,0,1,0.4,1,1v10C26,35.6,25.6,36,25,36z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D32F2F",
    d: "M18 4H26V12H18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8FireExtinguisher50);
export default __webpack_public_path__ + "static/media/icons8-fire-extinguisher-50.bcbc2d46a3e9b2208efcf0aed2bd67df.svg";
export { ForwardRef as ReactComponent };